import debugWallet from '../../helpers/debugWallet.js';
const buildEndpoint = _ref => {
  let {
    id,
    consumerid,
    method,
    environment
  } = _ref;
  const endpoints = {
    walletId: `/${method === 'POST' ? '' : `id/${id}`}`,
    consumerid: `/consumerid/${consumerid}`
  };

  // Use consumerid path if present and is a GET request only
  const useConsumeridPath = method === 'GET' && consumerid;
  const path = useConsumeridPath ? 'consumerid' : 'walletId';

  // https://wallet-storage-service-np.awsacsnp.autotrader.com/wallet/id/${id}
  const endpoint = `https://${environment === 'prod' ? 'www' : 'staging'}.kbb.com/my-wallet/storage/wallet${endpoints[path]}`;
  return endpoint;
};
async function WalletStorageFetcher(_ref2) {
  let {
    method,
    body,
    ...rest
  } = _ref2;
  try {
    const endpoint = buildEndpoint({
      method,
      ...rest
    });
    const options = {
      credentials: 'omit',
      method,
      headers: {
        'Content-Type': 'application/json'
      }
    };
    if (method === 'POST' || method === 'PUT') {
      options.body = JSON.stringify(body || {});
    }
    const response = await fetch(endpoint, options);
    if (method === 'POST') {
      const locationHeader = response?.headers?.get('Location') || '';
      const newId = locationHeader.replace(`${endpoint}id/`, '');
      debugWallet(`New Wallet Id generated from Wallet Central: ${newId}`);
      return {
        statusCode: response?.status,
        success: response?.ok,
        id: newId
      };
    }
    if (method === 'PUT') {
      return {
        statusCode: response?.status,
        success: response?.ok
      };
    }
    const data = await response.json();
    if (data?.paymentInfo && (data?.paymentInfo?.createdDate || data?.paymentInfo?.lastUpdated)) {
      return {
        body: data,
        statusCode: response.status,
        success: response?.ok
      };
    }
    // invalid wallet id
    return {
      statusCode: 404
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('WalletStorageFetcher Error: ', method, error);
    return {
      statusCode: 404
    };
  }
}
export { WalletStorageFetcher as default };
